import React from 'react';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { TextWithLine } from '../Banners/BannerText/bannerText';
import { SplitImageLabelPanel } from '../Panel/Split';

export const FeaturesUsp = ({ label, list }) => (
  <div className='py-12 flex flex-col items-center'>
    <div className='block main-wrapper py-4 pb-16 lg:px-10 w-full'>
      <TextWithLine
        label={{ ...label, size: '5xl', color: { classname: 'gray-800' } }}
      />
    </div>
    {/* Usp list as split image label panels */}
    <div className='w-screen grid grid-cols-1 border-t border-b flex-col items-center'>
      {list.items.map((feature, index) => {
        return (
          <div className='col-span-1'>
            <SplitImageLabelPanel
              index={index}
              {...formatContentfulComponentProps(feature)}
              isFullScreenWidth={{ value: false }}
            />
          </div>
        );
      })}
    </div>
  </div>
);
